export const createPlatformsApi = (fetchApi) => {

  function getPlatforms() {
    return fetchApi(`/platforms`, 'GET');
  }

  return {
    getPlatforms
  };
};